import React from 'react';
import { motion } from 'framer-motion';

const Section = ({ id, title, subtitle, children }) => {
  return (
    <section id={id} className="section">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
      >
        {(title || subtitle) && (
          <header className="section-header">
            {subtitle && <p className="eyebrow">{subtitle}</p>}
            {title && <h2 className="title gradient-text">{title}</h2>}
          </header>
        )}
        <div className="section-body">
          {children}
        </div>
      </motion.div>
    </section>
  );
};

export default Section;
